/*
  Divider.jsx
*/

// Npm.
import React from 'react';

// Makes.
import { makeStyles, cx } from '../../makes/makeStyles';

// Styles.
const useStyles = makeStyles(theme => ({
  root: {
    margin: 0,
    flexShrink: 0,
    borderWidth: '0px 0px thin',
    borderStyle: 'solid',
    borderColor: theme.color_divider,
  },
}));

/**
 * Renders a simple horizontal line.
 */
export default function Divider({ className, ...rest }) {

  const classes = useStyles();

  return (
    <hr className={cx('Divider', classes.root, className)} {...rest} />
  );
}
